// Java
export const baseURL = 'https://team-32-anywhere-fitness.herokuapp.com'

// Node
// export const baseURL = 'https://anywhere-fitness-web40.herokuapp.com'